"use client";

import notionLogo from "@/app/(public)/shared/assets/logos/notion.png";
import nutrienLogo from "@/app/(public)/shared/assets/logos/nutrien.svg";
import supabaseLogo from "@/app/(public)/shared/assets/logos/supabase.png";
import { motion } from "framer-motion";

const ScrollingLogos = () => {
  const logos = [
    { src: "/landing/google.svg", name: "Google" },
    { src: notionLogo.src, name: "Notion" },
    { src: nutrienLogo.src, name: "Nutrien" },
    { src: supabaseLogo.src, name: "Supabase" },
    { src: "/landing/pylon.svg", name: "Pylon" },
    { src: "/landing/signalfire.svg", name: "Signalfire" },
    { src: "/landing/quantstamp.svg", name: "Quantstamp" },
    { src: "/landing/camus.svg", name: "Camus" },
  ];

  return (
    <div className="flex-1 flex justify-start items-center overflow-hidden">
      <motion.div
        className="flex items-center gap-8 sm:gap-20"
        animate={{
          x: [0, -1152], // 8 logos * 144px (128px + 48px gap) = 1152px
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 30,
            ease: "linear",
          },
        }}
        style={{ width: "3456px" }} // 24 logos * 144px = 3456px (3 sets of 8 logos)
      >
        {/* First set of logos */}
        {logos.map((logo, index) => (
          <div
            key={`first-${index}`}
            className="flex-shrink-0 flex items-center justify-center w-20 sm:w-32 h-8 sm:h-12"
          >
            <img
              src={logo.src}
              alt={logo.name}
              className="w-auto h-6 sm:h-8 max-w-[80px] sm:max-w-[120px] object-contain opacity-60 transition-all duration-300"
            />
          </div>
        ))}

        {/* Second set for seamless loop */}
        {logos.map((logo, index) => (
          <div
            key={`second-${index}`}
            className="flex-shrink-0 flex items-center justify-center w-20 sm:w-32 h-8 sm:h-12"
          >
            <img
              src={logo.src}
              alt={logo.name}
              className="w-auto h-6 sm:h-8 max-w-[80px] sm:max-w-[120px] object-contain opacity-60 transition-all duration-300"
            />
          </div>
        ))}

        {/* Third set for extra smooth looping */}
        {logos.map((logo, index) => (
          <div
            key={`third-${index}`}
            className="flex-shrink-0 flex items-center justify-center w-20 sm:w-32 h-8 sm:h-12"
          >
            <img
              src={logo.src}
              alt={logo.name}
              className="w-auto h-6 sm:h-8 max-w-[80px] sm:max-w-[120px] object-contain opacity-60 transition-all duration-300"
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default ScrollingLogos;
